import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { PORTAL_ORDER_QUERY, SELF_QUERY, CATEGORIES_QUERY } from '../../queries'
import { OCI } from '../../constants'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import { Container } from '../../styles/defaults'
import { StatusBar } from './styles'

import helpers from '../../helpers'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import ShoppingCartOrders from '../../components/ShoppingCartOrders';

class ShoppingCart extends Component {
  render() {
    const ociPlatform = window.sessionStorage.getItem(OCI)
    let statusContent = ociPlatform ? `U staat op het punt de onderstaande bestelling te plaatsen. U kunt hier uw bestelling controleren,<br/><br/>Zodra u de bestelling plaatst wordt deze in behandeling genomen binnen ${ociPlatform}. De bestelling moet binnen 2 dagen goedgekeurd worden in ${ociPlatform}. Na goedkeuring zullen wij de bestelling verwerken. Indien we geen goedkeuring ontvangen binnen 2 dagen zullen we de bestelling annuleren.` : 'U staat op het punt de onderstaande bestelling te plaatsen. U kunt hier uw bestelling controleren en eventueel een gewenste leverdatum en referentie invullen. Vult u geen leverdatum in? Dan proberen we binnen 2 werkdagen te leveren.<br/><br/>Zodra u de bestelling verzend gaan wij aan de slag. Het kan tot maximaal 10 minuten duren voordat uw bestelling overal zichtbaar is.'
    return (
      <Fragment>
        <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title="Bestelling plaatsen" />
        <Breadcrumb title="Bestelling plaatsen" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="45%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let viewOrders = self.permissions.includes('VIEW_ORDERS') || self.role === 'MANAGER'
            let editOrder = self.permissions.includes('EDIT_ORDER') || self.role === 'MANAGER'
            let sendOrder = self.permissions.includes('SEND_ORDER') || self.role === 'MANAGER'
            let createOrder = self.permissions.includes('EDIT_ORDER') || self.role === 'MANAGER'
            let viewPrices = self.permissions.includes('VIEW_PRICES') || self.role === 'MANAGER'
            if (viewOrders) {
              return (
                <Query query={CATEGORIES_QUERY}>
                  {({ loading, error, data }) => {
                    if (loading) return <Loader from="45%" to="75%" fixed />
                    if (error) return <Error error="de producten" />
                    const { categories } = data
                    const strippedProducts = helpers.strippedProducts(categories)
                    if (!this.props.portalOrderId) {
                      return (
                        <Container mt mb>
                          Er zijn momenteel geen bestellingen beschikbaar.
                        </Container>
                      )
                    }

                    return (
                      <Query query={PORTAL_ORDER_QUERY} variables={{ id: this.props.portalOrderId }}>
                        {({ loading, error, data }) => {
                          if (loading) return <Loader from="75%" to="100%" fixed />
                          if (error) return <Error error="uw bestellijst" />
                          let type = 'portalOrder'
                          let order = {}

                          data[type].orderParts.map(orderPart => {
                            order[orderPart.id] = orderPart.amount
                            return null
                          })

                          const { servicePackage } = data[type].branch
                          if (servicePackage === 'Ondersteun') {
                            sendOrder = this.props.portalOrderId && (data[type].code !== '40') ? sendOrder : false
                            editOrder = this.props.portalOrderId && (data[type].code !== '40') ? editOrder : false
                            createOrder = false
                          } else {
                            editOrder = servicePackage === 'Flexibel' && this.props.portalOrderId && (data[type].code !== '40') ? editOrder : false
                            sendOrder = servicePackage === 'Flexibel' && this.props.portalOrderId && (data[type].code !== '40') ? sendOrder : false
                            createOrder = servicePackage === 'Flexibel' && !this.props.portalOrderId &&  (data[type].code !== '40') ? createOrder : false
                          }


                          if (data[type].submitted && ociPlatform) {
                            statusContent = `U kunt deze bestelling niet meer wijzigen. Deze dient eerst door ${ociPlatform} goedgekeurd te worden. Zodra dit is gebeurd zal de bestelling verzonden worden. Had de bestelling al goedgekeurd moeten zijn? Neem dan contact met ons op.`
                            sendOrder = false
                          }

                          if (data[type].code === '40') {
                            return (
                              <Container mt mb>
                                Er zijn momenteel geen bestellingen beschikbaar.
                              </Container>
                            )
                          }
                          return (
                            <Fragment>
                              <Container mt>
                                <StatusBar dangerouslySetInnerHTML={{__html: statusContent}} />
                              </Container>
                              <ShoppingCartOrders
                                order={order}
                                products={this.props.products}
                                wholeOrder={data[type]}
                                strippedProducts={strippedProducts}
                                priceAgreements={this.props.branch.priceAgreements}
                                viewPrices={viewPrices}
                                orderId={data[type].id}
                                editOrder={false}
                                user={self}
                                branch={this.props.branchId}
                                sendOrder={sendOrder}
                                branchData={this.props.branch}
                              />
                            </Fragment>
                          )
                        }}
                      </Query>
                    )
                  }}
                </Query>
              )
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om de bestellingen te bekijken
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(ShoppingCart)



// WEBPACK FOOTER //
// ./src/views/ShoppingCart/index.js